/* eslint-env browser, amd */
console.log('site-core: desktop');

require('../scripts/site-all');
